import { cn } from "@/lib/utils";
import { Star } from "lucide-react";

interface QuestLogoProps {
  size?: number;
  className?: string;
}

export const QuestLogo = ({ size = 24, className = "" }: QuestLogoProps) => {
  return (
    <Star
      className={cn("text-yiedl-primary", className)}
      size={size}
    />
  );
};
